import React from 'react';
import _NeedOffersByCategoryContainer from './_NeedOffersByCategoryContainer.scss';
import NeedOffersByCategory from 'components/partials/need-offer-by-category';
import {Categories} from 'api';
import {Link} from 'react-router-dom';

class NeedOffersByCategoryContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      limit: 6
    };
  }

  componentDidMount() {
    const params = {
      filter: {
        limit: this.state.limit
      }
    };
    Categories.actions.categoryDemand.request(params).then(response => {
      response.data.sort((a, b) => {
        return b.countApprovedDemands - a.countApprovedDemands;
      });
      this.setState({
        data: response.data.slice(0, this.state.limit)
      });
    });
  }

  render() {
    return (
      <section className="need-offer-by-category-container landing-page">
        <div className='need-offer-by-category-wrap'>
          <div className='content-justify need-offer-by-category-title-wrap'>
            <h2 className='need-offer-by-category-title'>Nhu cầu cần kết nối</h2>
            <Link className='view-more-link' to='demands'>Xem tất cả</Link>
          </div>
          <div className='wrap-item'>
            {this.state.data.map((item, i) => {
              return (<NeedOffersByCategory {...item} key={i}/>);
            })}
          </div>
        </div>
      </section>
    );
  }
}

export default NeedOffersByCategoryContainer;



// WEBPACK FOOTER //
// ./components/home/sub-view/NeedOffersByCategoryContainer.jsx